// ===== SWAK CHANGE START — 2026-07-06 — Phase 0e school finder =====
(function () {
  var COOKIE_NAME = 'swak_campus';
  var COOKIE_DAYS = 30;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  function init() {
    // Auto-redirect if cookie already set
    var existing = getCookie(COOKIE_NAME);
    if (existing && window.SWAK_CAMPUS_DATA && window.SWAK_CAMPUS_DATA[existing]) {
      window.location.replace('/pages/' + existing);
      return;
    }

    var input = document.getElementById('swak-school-input');
    var dropdown = document.getElementById('swak-school-dropdown');
    if (!input || !dropdown || !window.SWAK_CAMPUS_DATA) return;

    // ===== SWAK CHANGE START — 2026-07-07 — use object key as slug =====
var campuses = Object.entries(window.SWAK_CAMPUS_DATA).map(function(entry) {
  return Object.assign({}, entry[1], { slug: entry[0] });
});
// ===== SWAK CHANGE END — 2026-07-07 — use object key as slug =====

    // ===== SWAK CHANGE START — 2026-07-07 — null guard on campus name/slug filter =====
input.addEventListener('input', function () {
  var q = input.value.trim().toLowerCase();
  dropdown.innerHTML = '';
  if (q.length < 2) { dropdown.style.display = 'none'; return; }

  var matches = campuses.filter(function (c) {
    if (!c || !c.name || !c.slug) return false;
    return c.name.toLowerCase().includes(q) || c.slug.toLowerCase().includes(q);
  }).slice(0, 8);

  if (!matches.length) { dropdown.style.display = 'none'; return; }

  matches.forEach(function (c) {
    var item = document.createElement('div');
    item.className = 'swak-finder__item';
    item.textContent = c.name;
    item.addEventListener('click', function () {
      setCookie(COOKIE_NAME, c.slug, COOKIE_DAYS);
      window.location.href = '/pages/' + c.slug;
    });
    dropdown.appendChild(item);
  });
  dropdown.style.display = 'block';
});
// ===== SWAK CHANGE END — 2026-07-07 — null guard on campus name/slug filter =====

    // Close dropdown on outside click
    document.addEventListener('click', function (e) {
      if (!input.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// ===== SWAK CHANGE END — 2026-07-06 — Phase 0e school finder =====
